import React, { Fragment, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const Dropdown = ({
  label,
  options,
  defaultValue,
  width = 'auto',
  onChange,
}) => {
  const [value, setValue] = useState(defaultValue ?? 0);
  const handleSelect = (val) => {
    setValue(val);
    onChange(val);
  };
  return (
    <Menu as='div' className='relative inline-block text-left  w-full'>
      <div>
        <Menu.Button
          style={{
            minWidth: 80,
            width,
            justifyContent: 'space-between',
            display: 'flex',
          }}
          className='gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 border !border-[#ced4da]'
        >
          <span>{value > 0 ? options[value] : label}</span>
          <ChevronDownIcon
            className='-mr-1 h-5 w-5 text-gray-400'
            aria-hidden='true'
            style={{ display: 'inline' }}
          />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter='transition ease-out duration-100'
        enterFrom='transform opacity-0 scale-95'
        enterTo='transform opacity-100 scale-100'
        leave='transition ease-in duration-75'
        leaveFrom='transform opacity-100 scale-100'
        leaveTo='transform opacity-0 scale-95'
      >
        <Menu.Items className='absolute w-full right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'>
          <div className='py-1'>
            {Object.keys(options).map((value) => (
              <Menu.Item>
                {({ active }) => (
                  <span
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm'
                    )}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSelect(value)}
                  >
                    {options[value]}
                  </span>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
export default Dropdown;
